import { Delete, Pencil, Trash } from 'lucide-react';
import React from 'react'
import { HTTP } from '../../api/http-common';
import Swal from "sweetalert2";

function CategoryList({category,handleEditCategory,role,fetchTableData}) {
  // console.log(category)
  const editChange = (category) => {
    handleEditCategory(category);
  };
  const handleDelete = async (id) => {
    const access_token = localStorage.getItem("access_token");
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    try {
      const access_token = localStorage.getItem('access_token');
      let config = {
      headers: { "Content-Type": "application/json", token: access_token },
      };

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        await HTTP.delete(
            `business_cate/delete/${id}`,
            config
        )
          .then(async (response) => {
            if (response.status === 200) {
                Swal.fire({
                    title: response.data.message,
                  //   text: "Please verify your email before login",
                    icon: "success"
                });
                fetchTableData()
              //   setUsermailToVerify(email);
              //   navigate('/verify');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                  title: 'Error!',
                  text: error.response.data.detail,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
            }
            if (error.response.status === 400) {
                Swal.fire({
                    title: 'Error!',
                    text: 'You are already registered!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                  })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
                Swal.fire({
                    title: 'Error!',
                    text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                  })
            }
          });
        // setIsLoading(false);
        }
      } catch (error) {
      }
  };
  
  return (
    <>
        <tr key={category.id}>
          <td className="admin-table-th-td">{category.id}</td>
          <td className="admin-table-th-td">{category.name}</td>
          
          <td className="admin-table-th-td w-1/6">
            <div className="flex items-center justify-center">
            <span className='text-[#6c1cff] pe-2'>
              <Pencil className='w-4 h-4 ' onClick={() => editChange(category)}/>
            </span>
            <span className='text-[#ff0000] pe-2'>
              <Trash className='w-4 h-4 ' onClick={() => handleDelete(category.id)}/>
            </span> 
            </div>
          </td>
        </tr>
    </>
  )
}

export default CategoryList